export default __webpack_public_path__ + "static/media/Ram-Ghat.a5293184.jpg";